var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConversion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1710,
    height: 1472,
    viewBox: "0 0 1710 1472",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_3522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1706.38 736.01V752.06L1652.56 775.61L1335.76 914.2L1021.26 1242.48L967.44 1298.66L965.14 1301.06V1285.01L1335.76 898.15L1706.38 736.01Z",
    fill: "#E6EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652.56 775.609V963.489L967.44 1470.92V1298.66L1021.26 1242.48L1335.76 914.199L1652.56 775.609Z",
    fill: "#E6EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.44 1298.66V1470.92L702.84 1257.82V1089.81L965.14 1301.06L967.44 1298.66Z",
    fill: "#F4F5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.14 1285.01V1301.06L702.84 1089.81L700.54 1087.96V1071.9L965.14 1285.01Z",
    fill: "#F4F5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.44 471.039L700.54 1071.9L532.18 1196.6L266.47 870.229L805.44 471.039Z",
    fill: "#E6EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.84 1089.81V1257.82L506.43 1403.29V1181.02L532.18 1212.65L700.54 1087.96L702.84 1089.81Z",
    fill: "#E6EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.54 1071.9V1087.96L532.18 1212.65V1196.6L700.54 1071.9Z",
    fill: "#E6EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.43 1181.02L266.47 886.28L82.62 815.96L0.75 784.64V768.59L266.47 870.23L532.18 1196.6V1212.65L506.43 1181.02Z",
    fill: "#F4F5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.43 1181.02V1403.29L82.6201 1061.97V815.959L266.47 886.279L506.43 1181.02Z",
    fill: "#F4F5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.11 643.889L805.44 471.039",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.54 1071.9L805.44 471.039",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.54 1087.96V1071.9",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.85 1257.82V1089.81",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1709.51 499.89V483.35",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.54 1087.96L532.19 1212.65L266.47 886.281L0.75 784.641V768.581L169.11 643.891",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.54 1087.96L965.14 1301.06L1021.26 1242.48L1335.76 914.2L1706.38 752.06V736.01L910.35 94.9004L539.73 257.03L169.11 643.89",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.85 1257.82L506.43 1403.29L82.6299 1061.97V815.961",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.85 1257.82L967.44 1470.92L1652.56 963.49V775.6",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.19 1212.65V1196.6L700.54 1071.9",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.44 471.039L266.47 870.229L0.75 768.579",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.73 257.029L805.44 471.039L1335.76 898.149",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.38 736.01L1335.76 898.15L965.14 1285.01V1301.06",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.43 1181.01V1403.29",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.44 1298.65V1470.92",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.19 1196.6L266.47 870.23",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.54 1071.9L965.14 1285.01",
    stroke: "#8A8ADD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6299 815.95L266.47 886.28L532.19 1212.65L700.54 1087.96L965.14 1301.06L1335.76 914.2L1652.56 775.6",
    stroke: "#8A8ADD",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.85 1257.81L967.44 1470.91L1652.56 963.481V775.601L1706.38 752.051V736.001L910.35 94.8906L539.73 257.031L169.11 643.881L0.75 768.581V784.631L82.63 815.951V1061.96L506.43 1403.28L702.85 1257.81Z",
    stroke: "#2E24B6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_3522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1710,
    height: 1472,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversion);
export default __webpack_public_path__ + "static/media/conversion.e5cba938f99e23d60d82cc15724ecb22.svg";
export { ForwardRef as ReactComponent };